import React from "react";
import PlaceholderBar from "./PlaceholderBar";

const TitleListComponent = ({ data, loading, siteTheme }) => {
	return (
		<div
			className={`flex flex-col items-start gap-1 mb-3 ${siteTheme.cardBackground} break-inside-avoid-column p-5 rounded-2xl`}>
			<div className="flex flex-row items-center gap-2 mb-0">
				{data?.Icon}
				<h1 className="w-full font-normal tracking-widest">{data?.title}</h1>
			</div>
			{loading ? (
				<>
					<PlaceholderBar classname="w-full h-[10px] placeholder" />
					<PlaceholderBar classname="w-full h-[10px] placeholder" />
					<PlaceholderBar classname="w-full h-[10px] placeholder" />
				</>
			) : Array.isArray(data?.data) ? (
				<ul className="list-inside">
					{data?.data?.map((consl, idx) => (
						<li
							key={idx}
							className="text-xs list-[disc] tracking-widest leading-6">
							{consl}
						</li>
					))}
				</ul>
			) : (
				<p className="w-full text-xs leading-6 tracking-widest">{data?.data}</p>
			)}
		</div>
	);
};

export { TitleListComponent };
export default TitleListComponent;
